import { RulesetResult } from '../../business/rules';
import { PgFiledTaxes3YearsAgoRuleset } from '../../business/ruleset';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';

const { pgFiledTaxes3YearsAgo } = loanFormModel.formField;

export class PgFiledTaxes3YearsAgoValidation implements ValidationSchema {
  public name = pgFiledTaxes3YearsAgo.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public ruleset = PgFiledTaxes3YearsAgoRuleset;

  public when(schema: any, ...args: any[]) {
    return schema.test({
      name: 'pgFiledTaxes3YearsAgoValidation',
      test: function (value, context) {
        // Principal-level field (not under documents): from[1] = application
        const application: Partial<ApplicationFormValues> =
          this.from?.[1]?.value ?? {};
        const principalId = this.parent?.id;

        const result: RulesetResult =
          PgFiledTaxes3YearsAgoRuleset.setPrincipalId(principalId).evaluate(
            application
          );

        const required = !!(result & RulesetResult.REQUIRED);

        if (
          required &&
          (value === null || value === undefined || value === '')
        ) {
          return this.createError({
            message: 'This field is required',
          });
        }
        return true;
      },
    });
  }
}

export default new Validation(new PgFiledTaxes3YearsAgoValidation());
